import { Factory } from 'miragejs';

export default Factory.extend({
  acceptDeliveries: false,
  beenHereBefore: false,
  hasPhotoPage: null,
  integrations: () => [],
  onlyShowSlideshow: false,
  selfSignOut: false,
  slideshowIds: () => [],
  welcomeImage: null,
  slideshows: null,
  staticQrEnabled: false,
  localizedFields: () => [
    {
      field: 'Your Full Name',
      localized: 'Your Full Name',
    },
    {
      field: 'Your Email Address',
      localized: 'Your Email Address',
    },
    {
      field: 'Your Phone Number',
      localized: 'Your Phone Number',
    },
    {
      field: 'Host',
      localized: 'Host',
    },
  ],
});
